export default __webpack_public_path__ + "static/media/d_doctor.93411793.png";